<div class="container content-container position-relative" [ngClass]="{ 'mt-4 draft-list': isMobile }">
    <!-- <div class="overlay-aq form-height d-flex justify-content-center py-3form-height d-flex justify-content-center py-3" *ngIf="isloading">
        <div class="loader-class">
            <span class=" ">Please wait</span><img src="./../../../assets/gifs/loader_sand.gif" alt="Processing icon" />
        </div>
    </div> -->
    <div class="d-flex justify-content-center align-items-center loader-container" *ngIf="isloading">
        <div class="loader-class d-flex flex-column justify-content-center align-items-center text-center">
            <img src="./../../../assets/gifs/loader_sand.gif" alt="Processing icon" />
            <span>Please wait</span>
        </div>
    </div>
    <div class="draft-container" *ngIf="!isloading" #containerDraftDiv (scroll)="onDraftContinerScroll()">
        <div class="row draft-content">
            <div class="col-md-4 mb-4" *ngFor="let item of savedDrafts; let i = index">
                <div class="card">
                    <div
                        class="d-flex justify-content-between cursor-pointer"
                        [attr.id]="'populate-draft-' + i"
                        [attr.data-test]="'populate-draft-' + i"
                        (click)="populateDraft(item)"
                    >
                        <span class="draft-item align-items-center justify-content-between">
                            <img class="w-3 h-1 align-items-center icon-gyan" src="../../../assets/organisation/icon-gyan-card.svg" alt="Gyan icon" />

                            <ng-container>
                                <span title="{{ item.name }}" class="draft-name d">{{ item.name | truncate: 30 }}</span>
                            </ng-container>
                            <ng-container>
                                <div title="{{ item.time }}" class="draft-date">{{ item.time }}</div>
                            </ng-container>
                        </span>
                        <div
                            (click)="$event.stopPropagation(); checkForDeleteGyan(item, deleteDrafModal)"
                            class="comment-box-items comment-box-items-delete cursor-pointer col-auto gray-color align-items-center d-flex"
                            [attr.id]="'delete-draft-' + i"
                            [attr.data-test]="'delete-draft-' + i"
                        >
                            <img class="align-items-center option-icon icon-delete-height icon-delet" src="../../../assets/icon-delete.svg" alt="Delete icon" title="Delete Icon" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="noDraftText" *ngIf="(savedDrafts && savedDrafts.length === 0) || isNocontent">No Drafts Available</div>
        </div>
    </div>

    <!-- Inline Loader (Only shown while fetching new data) -->
    <div *ngIf="isloadingScroll">
        <div class="loader-class d-flex flex-column justify-content-center align-items-center text-center">
            <img src="./../../../assets/gifs/loader_sand.gif" alt="Processing icon" />
            <span>Please wait</span>
        </div>
    </div>

    <div *ngIf="isloadingScrollDelete">
        <div class="loader-class d-flex flex-column justify-content-center align-items-center text-center">
            <img src="./../../../assets/gifs/loader_sand.gif" alt="Processing icon" />
            <span>Please wait</span>
        </div>
    </div>
</div>
<ng-template #deleteDrafModal let-modal>
    <div class="modal-header d-flex">
        <div class="modal-title">Delete Draft</div>
        <div
            type="button"
            class="gyan-popup-close"
            aria-label="Close"
            (click)="modal.dismiss('Cross click')"
            [attr.id]="']delete-draft-modal-close'"
            [attr.data-test]="'delete-draft-modal-close'"
        >
            <div class="modal-close-icon"></div>
        </div>
    </div>
    <div class="modal-body1 delete-container-body">
        <div>
            <div class="my-3 px-0">
                <div class="d-flex justify-content-center align-items-center">Are you sure you want to delete?</div>
            </div>
        </div>
    </div>
    <div class="modal-footer delete-modal d-flex justify-content-center align-items-center border-0">
        <button type="button" class="btn modalactionbtn" (click)="callDeleteDraft()" [attr.id]="'confrim-draft'" [attr.data-test]="'confrim-draft'">Confirm</button>
        <button type="button" class="btn modalactionbtn" (click)="modal.close('Close click')" [attr.id]="'cancel-draft'" [attr.data-test]="'cancel-draft'">Cancel</button>
    </div>
</ng-template>
